import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, FieldArray, Form, Formik, FormikErrors } from 'formik'
import { Adapter, IFormHealthProfile, Pattern, SeasonDto, UserHealthRequestDto, UserHealthService } from '../../modules/core'
import { catchErrorMsg } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FormDataPicker, FormInputNumber, FormRadio } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import { RootState } from 'setup'
import { shallowEqual, useSelector } from 'react-redux'
import moment from 'moment'

type Props = {

}

let initValue: IFormHealthProfile = {
    id: 0,
    userProfileId: '',
    recordDate: new Date(),
    sexCode: 'M',
    weight: 0,
    height: 0,
    hb: 0,
    hct: 0,
    gluclose: 0,
    uricAcid: 0,
    cholesterol: 0,
    triglyceride: 0,
    hdl: 0,
    ldl: 0,
    urine: 'Normal',
    other: ''
}
const formSchema = Yup.object().shape({
    recordDate: Yup.date().required('require'),
    sexCode: Yup.string().required('require'),
    weight: Yup.number().required('require'),
    height: Yup.number().required('require'),
    hb: Yup.number().required('require'),
    hct: Yup.number().required('require'),
    gluclose: Yup.number().required('require'),
    uricAcid: Yup.number().required('require'),
    cholesterol: Yup.number().required('require'),
    triglyceride: Yup.number().required('require'),
    hdl: Yup.number().required('require'),
    ldl: Yup.number().required('require'),
    urine: Yup.string().required('require'),
    //other: Yup.string().required('require')
})



export const ProfileHealthPage: FC<Props> = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<IFormHealthProfile>(initValue)
    const { id } = useParams()
    const navigate = useNavigate()
    useEffect(() => {
        const init = () => {
            if (id && id !== 'new') {
                //setSeasonMonth()
                UserHealthService.GetById(parseInt(id)).then((result) => {
                    const res = result.data.result
                    if (res) {
                        const frmDto = Adapter.FormUserHealth(res);
                        setData(frmDto)
                    }

                })
            }
        }
        init()
    }, [id])

    const onSubmit = async (values: IFormHealthProfile) => {
        setLoading(true)
        const updatedData = Adapter.mapUserHealth(values)
        if (id === 'new') {
            Save(updatedData)

        } else if (id) {
            Update(parseInt(id), updatedData)
        }


    }

    const Save = (updatedData: UserHealthRequestDto) => {
        try {
            UserHealthService.Create(updatedData)
                .then((res) => {
                    setLoading(false)
                    toast.success('Save Success.')
                    navigate('/profile')

                }).catch((res) => {
                    toast.error(catchErrorMsg(res))
                    setLoading(false)
                })
        } catch (ex) {
            toast.error(catchErrorMsg(ex))
            setLoading(false)
        }
    }

    const Update = (id: number, updatedData: UserHealthRequestDto) => {
        try {
            UserHealthService.Update(id, updatedData).then(() => {
                toast.success('Update Success.')
                setLoading(false)
                navigate('/profile')
            }).catch((res) => {
                toast.error(catchErrorMsg(res))
                setLoading(false)
            }
            )
        } catch (ex) {
            toast.error(catchErrorMsg(ex))
            setLoading(false)
        }
    }


    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
        const inputCls = props.inputCls ?? 'col-lg-4'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>
                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

                </div>
                {props.textEnd && <div className={props.txtEndCls}>
                    <span > {props.textEnd}</span>
                </div>}
            </div>
        )
    }

    let minDate: Date | undefined = undefined;
    let maxDate: Date | undefined = undefined;
    if (lastSeason) {
        minDate = new Date(lastSeason.periodStart)
        const t_maxDate = new Date(lastSeason.periodEnd)
        maxDate = new Date(t_maxDate.getFullYear(), t_maxDate.getMonth() + 1, 0)
    }

    return (
        <>
            <PageTitle
                breadcrumbs={[
                    {
                        title: 'ประเมินตนเอง',
                        path: '/selfAssess',
                        isSeparator: false,
                        isActive: false,
                    },
                ]}
            >
                คะแนนพิเศษ
            </PageTitle>
            <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>
                </div>
                <Formik
                    enableReinitialize
                    initialValues={data}
                    validationSchema={formSchema}
                    onSubmit={onSubmit}
                    // validate={(v) => console.log(v)}
                >
                    {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                        <Form>
                            <>
                                {/* begin::Scroll */}
                                <div className='card-body p-9'>
                                    <CellStyle lable='วันตรวจ'>
                                        <Field
                                            as='text'
                                            name='recordDate'
                                            className={
                                                'form-control form-control-solid' +
                                                (errors.recordDate && touched.recordDate ? ' is-invalid' : '')
                                            }
                                            value={moment(values.recordDate).format('DD/MM/YYYY')}
                                            onDateChange={(value: Date, e: any) => {
                                                setFieldValue('recordDate', value)
                                            }}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            component={FormDataPicker}
                                        />
                                        {/* <ReactCalendar/> */}
                                        <ErrorMessage name={`recordDate`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='เพศ' inputCls='col-lg-2' txtEndCls='col-lg-2'>
                                        <div className='d-flex justify-content-between'>
                                            <Field
                                                label={'ชาย'}
                                                name={`sexCode`}
                                                gName={`sexCode`}
                                                gValue={'M'}
                                                component={FormRadio}

                                            />
                                            <Field
                                                label={'หญิง'}
                                                name={`sexCode`}
                                                gName={`sexCode`}
                                                gValue={'F'}
                                                component={FormRadio}
                                            />
                                        </div>
                                    </CellStyle>
                                    <CellStyle lable='น้ำหนัก'>
                                        <Field
                                            name='weight'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.weight && touched.weight ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`weight`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='ส่วนสูง'>
                                        <Field
                                            name='height'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.height && touched.height ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`height`} component='div' className='text-danger' />
                                    </CellStyle>


                                    <CellStyle lable='Hb' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='g/dL'>
                                        <Field
                                            name='hb'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.hb && touched.hb ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`hb`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='Hct' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='%'>
                                        <Field
                                            name='hct'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.hct && touched.hct ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`hct`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='Glucose' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='mg/dl'>
                                        <Field
                                            name='gluclose'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.gluclose && touched.gluclose ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`gluclose`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='Uric acid' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='mg/dl'>
                                        <Field
                                            name='uricAcid'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.uricAcid && touched.uricAcid ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`uricAcid`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='Cholesterol' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='mg/dl'>
                                        <Field
                                            name='cholesterol'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.cholesterol && touched.cholesterol ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`cholesterol`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='Triglyceride' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='mg/dl'>
                                        <Field
                                            name='triglyceride'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.triglyceride && touched.triglyceride ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`triglyceride`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='HDL' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='mg/dl'>
                                        <Field
                                            name='hdl'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.hdl && touched.hdl ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`hdl`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='LDL' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='mg/dl'>
                                        <Field
                                            name='ldl'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.ldl && touched.ldl ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2Digit}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`ldl`} component='div' className='text-danger' />
                                    </CellStyle>



                                    <CellStyle lable='Urine' inputCls='col-lg-2' >
                                        <div className='d-flex justify-content-between'>
                                            <Field
                                                label={'ปกติ'}
                                                name={`urine`}
                                                gName={`urine`}
                                                gValue={'Normal'}
                                                component={FormRadio}

                                            />
                                            <Field
                                                label={'ผิดปกติ'}
                                                name={`urine`}
                                                gName={`urine`}
                                                gValue={'AbNormal'}
                                                component={FormRadio}
                                            />
                                        </div>
                                    </CellStyle>

                                    <CellStyle lable='ความผิดแกติอื่นๆ'>
                                        <Field
                                            as='textarea'
                                            autoComplete='off'
                                            name='other'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.other && touched.other ? ' is-invalid' : '')
                                            }
                                            rows={3}
                                        />
                                        <ErrorMessage name={`other`} component='div' className='text-danger' />
                                    </CellStyle>

                                </div>
                                {/* end::Scroll */}

                                <div className='card-footer d-flex py-6 px-9'>
                                    <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                                        {!loading && 'Save Changes'}
                                        {loading && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>

                                    <button className='btn btn-light' onClick={() => navigate('/profile')}> Back</button>
                                </div>
                            </>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}

